import type { UserOrganization, UserProfile } from "~/types/api";

export function accessibleOrganizations(
  organizations: UserOrganization[],
  profiles: UserProfile[] | null | undefined,
): UserOrganization[] {
  const profileLocationIds = new Set((profiles ?? []).map((profile) => String(profile.location.id)));

  return organizations.flatMap((organization) => {
    const locations = organization.locations.filter((location) => profileLocationIds.has(String(location.id)));

    return locations.length > 0 ? [{ ...organization, locations }] : [];
  });
}
